import type { BusinessIntelligenceRepresentationConfig } from '@/interfaces/BusinessIntelligenceRepresentation.interface';
import { Directive, type EventEmitter, Input, Output } from '@angular/core';
import type { BusinessIntelligenceDimension, BusinessIntelligenceMeasure } from '../../../interfaces/BusinessIntelligence.interface';

@Directive()
export abstract class BusinessIntelligenceRepresentationConfigEditorComponent<
    ConfigToEdit extends BusinessIntelligenceRepresentationConfig
> {
    @Input() config!: ConfigToEdit;
    @Input() availableMeasures!: BusinessIntelligenceMeasure[];
    @Input() availableDimensions!: BusinessIntelligenceDimension[];
    @Input() disabled!: boolean;

    @Output() configChanged!: EventEmitter<ConfigToEdit>;
}
